import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IConfigurationRolesAndPermissionListResponse } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});
export const useConfigurationRBACListAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(async () => {
    dispatch(
      setLoading({
        key: "isRolesAndPermissionListInProgress",
        status: true,
      }),
    );
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

      const response = await axios
        .get(`${CONFIGURATION_APIS?.LIST_ROLES_AND_PERMISSION?.baseURL}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IConfigurationRolesAndPermissionListResponse>) => {
          dispatch(
            setLoading({
              key: "isRolesAndPermissionListInProgress",
              status: false,
            }),
          );
          if (res.data.status === true) {
            return res.data.data;
          } else {
            toast.error("Error while fetching staff category list.");
            return null;
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          return null;
        });
      return response;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch(
          setLoading({
            key: "isOnboardStaffCategoryListInProgress",
            status: false,
          }),
        );
        const axiosError = error as AxiosError;
        if (axiosError.code === "ERR_BAD_REQUEST") {
          toast.error("Error at server while fetching staff category details.");
        }
        if (axiosError.response?.status === 400) {
          toast.error(axiosError.message);
        }
        if (axiosError.response?.status === 500) {
          toast.error("Internal Server Error, Contact Tech Team.");
        }
      } else {
        toast.error("Server Error: " + error.message);
      }
      return null;
    }
  }, [dispatch, configuration]);

  return execute;
};
